import React from 'react';
import styled, { keyframes } from 'styled-components';
import { common } from '../../../style';
import { neutral } from '../../../style/colors';

const SearchResultLoading = () => {
  return (
    <Wrapper>
      <h2>&nbsp;</h2>
      <h1>&nbsp;</h1>
      <div>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
      </div>
    </Wrapper>
  );
};
const pulse = keyframes`
  0% {
        background-color: ${neutral[100]};
    }
    50% {
        background-color: ${neutral[150]};
    }
    100% {
        background-color: ${neutral[100]};
    }
`;
const Wrapper = styled.div`
  margin: 5px;
  padding: 10px;
  width: 95%;
  height: 120px;
  background-color: ${common.backgroundColor};
  border: 1px solid ${common.backgroundColor};
  pointer-events: none;
  
  > * {margin: 0.5em 0;}
  h2 {
    animation: ${pulse} 1s infinite ease-in-out;
    width: 120px;
  }
  h1 {
    animation: ${pulse} 1s infinite ease-in-out;
    width: 180px;
  }
  div {
    display: flex;
    div:nth-child(1) {
      animation: ${pulse} 1s infinite ease-in-out;
      width: 50px;
    }
    div:nth-child(2) {
      margin-left: auto;
      animation: ${pulse} 1s infinite ease-in-out;
      width: 60px;
    }
  }
`;

export default SearchResultLoading;
